import React, {PropTypes} from 'react';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import CropImage from '../CropImage';
import DialogImage from '../DialogImage';
import ImageProcessor from '../../../utilites/ImageProcessor';
import IconAdd from '../../Icons/IconAdd';
import IconDelete from '../../Icons/IconDelete';
import IconReload from '../../Icons/IconReload';
import IconView from '../../Icons/IconView';
import {LiveImage} from '../../../api/image';

class ImageUpload extends React.Component {
  static propTypes = {
    format: PropTypes.oneOf(['image/jpeg', 'image/png']),
    disabled: PropTypes.bool,
    label: PropTypes.string,
    ImageClass: PropTypes.func.isRequired,
    crop: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired,
    setUpIncorrectImage: PropTypes.any,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    imageOnLoad: PropTypes.func
  };

  state = {
    editItem: false,
    needCrop: false,
    croppedUri: null,
    dataUri: null,
    openModal: false
  };

  componentWillMount() {
    this._id = `ImageUpload${(new Date()).getTime()}`;
    this._parseProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    this._parseProps(newProps);
  }

  _parseProps(props) {
    let {error} = props;

    this.setState({error: this.state.errorValidate || error || []});
  }

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  toggleEdit = (editItem) => {
    this.setState({editItem});
  };

  getStyle() {
    let imageWidth = 200 ? this.props.imageWidth : 200;
    let imageHeight = 200 ? this.props.imageHeight : 200;
    let {muiTheme} = this.context;
	  let {disabled, displayPosition} = this.props;
    let {editItem} = this.state;

    const grayColor = 'rgba(51, 51, 51, 0.8)';
    return {
      block: {
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: grayColor,
        display: 'block',
        width: '100%'
      },
      icon: {
        textAlign: 'center',
        cursor: disabled ? 'default' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: imageWidth,
        height: imageHeight,
        margin: '0 auto'
      },
      image: {
        display: 'block',
        margin: '0 auto',
        maxWidth: '100%'
      },
      editImageHover: {
        display: disabled || !editItem ? 'none' : 'flex',
        backgroundColor: grayColor,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        alignItems: 'center',
        justifyContent: displayPosition ? displayPosition : 'center'
      },
      editImageHoverButtons: {
        maxWidth: 194
      },
      button: {
        cursor: 'pointer',
        backgroundColor: 'rgb(0, 0, 0, 0.6)',
        color: muiTheme.appBar.textColor
      }
    };
  }

  reload() {
    this.refs.fileInput.click();
  }

  handleCrop(crop) {
    let {crop: {width, height}, format} = this.props;

    this.state.imageProcessor.cropPercentage(crop, width, height, format)
      .then(this.changeValue);
  }

  handleOpen = () => {
    this.setState({
      openModal: true
    });
  };

  changeValue = (blob) => {
    const {ImageClass} = this.props;
    let newImage = new ImageClass(blob);

    let {onChange, onBlur} = this.props;
    onChange(newImage);
    onBlur(newImage);
  };

  handleClose = () => {
    this.setState({openModal: false});
  };

  readAsDataURLFile(file) {
    return new Promise(res => {
      let reader = new FileReader();
      this.file = file;

      reader.onload = (upload) => {
        res(upload.target.result);
      };

      reader.readAsDataURL(this.file);
    });
  }

  handleFileTap() {
    this.setState({
      errorValidate: null
    });
    // this.props.onFocus();
  }

  async handleFileChoose(file) {
    // this.props.onFocus();
    let uri = await this.readAsDataURLFile(file);
    this.setState({
      errorValidate: null,
      dataUri: uri,
      imageProcessor: new ImageProcessor(uri)
    });

    let imageProcessor = this.state.imageProcessor;

    let isCropNeeded = await imageProcessor.isBigger(this.props.crop);
    let isExactSize = await imageProcessor.isEqual(this.props.crop);
    let isSmaller = await imageProcessor.isSmaller(this.props.crop);

    this.setState({needCrop: isCropNeeded});

    if (!this.props.setUpIncorrectImage && isSmaller) {
      alert('Please make sure your picture has right dimensions.')
      this.props.onBlur(null);
    }

    if (!isCropNeeded && (this.props.setUpIncorrectImage || isExactSize)) {
      // console.log("success")
        this.changeValue(file);
    }
  }

  clearValue() {
    this.setState({
      needCrop: false,
      croppedUri: null,
      dataUri: null
    });

    // this.props.onBlur();
    this.props.onChange(null);
    this.props.onBlur(null);
  }

  render() {
    let style = this.getStyle();
    let {disabled, value, iconView, textSize, invalid} = this.props;
    let {openModal} = this.state;

    let dialogOptions = {
      openModal,
      onRequestClose: this.handleClose
    };

    return (
      <Paper zDepth={1}>
        <div style={style.block}>
          { !value || invalid || value.original === ''
            ? (
            <div>
              <label htmlFor={this._id} onMouseDown={() => this.handleFileTap()}>
                <div style={style.icon}>
                  <div>
                    <IconAdd style={{width: 20, height: 20, color:'white'}}/>
                    <div style={{color: 'white', fontSize: textSize ? textSize : 16}}>Add image</div>
                  </div>
                </div>
              </label>
            </div>
          )
            : (
            <div onMouseEnter={() => this.toggleEdit(true)} onMouseLeave={() => this.toggleEdit(false)}>
              <div style={style.editImageHover}>
                <IconButton onClick={this.handleOpen} style={iconView}>
                  <IconView color='white'/>
                </IconButton>
                <IconButton onClick={() => !disabled && this.reload()}>
                  <IconReload color='white'/>
                </IconButton>
                <IconButton onClick={() => !disabled && this.clearValue()}>
                  <IconDelete color='white'/>
                </IconButton>
              </div>
              {/*@TODO refactor this*/}
              <img src={value.url || value.small || value.preview} style={style.image} onLoad={this.props.imageOnLoad}/>
              <DialogImage
                {...dialogOptions}
              >
                <img src={value.url || value.original} style={style.image}/>
              </DialogImage>
            </div>
          )
          }
        </div>
        <input id={this._id}
               disabled={disabled}
               type='file'
               accept='image/*'
               ref='fileInput'
               style={{display: 'none'}}
               onClick={(e)=>{e.target.value=null;}}
               onChange={(e) => {
                   if (e.target.files[0]) {
                     this.handleFileChoose(e.target.files[0]);
                   }
                 }}/>
        {this._renderCrop()}
      </Paper>
    );
  }

  _renderCrop() {
    let {crop: {width, height}} = this.props;
    let {dataUri, needCrop} = this.state;

    return needCrop && dataUri !== null
      ? React.createElement(CropImage, {
      dataUri,
      width,
      height,
      onCrop: crop => {this.handleCrop(crop)},
      onClose: () => {
        this.setState({
          needCrop: false
        })
      }
    })
      : null;
  }
}

ImageUpload.defaultProps = {
  onBlur: () => {},
  setUpIncorrectImage: false,
  format: 'image/jpeg',
  ImageClass: LiveImage,
  crop: {
    width: 100,
    height: 100
  },
  imageOnLoad: () => {}
};


export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/form/ImageUpload/ImageUpload.jsx